import accountSummaryTemplate from 'views/dashboard/account-summary.html';
import { AccountSummaryController } from './account-summary.controller';

export class AccountSummaryComponent implements ng.IComponentOptions {
  public controller = AccountSummaryController;
  public templateUrl: string = accountSummaryTemplate;
}
